import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "DocumentUpload" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
